import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import axios from "axios"
import Sidebar from "../components/Sidebar"
import DashboardHeader from "../components/DashboardHeader"
import WishlistCourseCard from "../components/WishlistCourseCard"

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const WishlistPage = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [wishlistCourses, setWishlistCourses] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [profilePhoto, setProfilePhoto] = useState(null);

  const accessToken = useSelector((state) => state.auth.access)
  const user = useSelector((state) => state.auth.user);

  // Fetch profile photo separately
    useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const token = localStorage.getItem("access");
          const res = await axios.get(`${BASE_URL}/users/profile/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const p = res.data.profile_photo;
          if (p) {
            setProfilePhoto(
              p.startsWith("http") ? p : `${BASE_URL}${p}`
            );
          } else {
            setProfilePhoto(null);
          }
        } catch (e) {
          setProfilePhoto(null);
        }
      };
      fetchUserProfile();
    }, []);

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/users/wishlist/`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
    
        const formatted = res.data.results.map((item) => ({
          id: item.course.id,
          title: item.course.title,
          image: item.course.image,
          rating: item.course.average_rating || 0,
          reviewCount: item.course.review_count || 0,
          instructor: {
            name: item.course.instructor || "-",
            image: item.course.instructor_image || "/placeholder.svg",
          },
        }))
    
        setWishlistCourses(formatted)
      } catch (err) {
        setError("Failed to load wishlist.")
      } finally {
        setLoading(false)
      }
    }    

    if (accessToken) fetchWishlist()
  }, [accessToken])

  const userData = {
    name: user?.username || "User",
    initials: user?.username?.slice(0, 2).toUpperCase() || "U",
    notificationCount: 4,
  }

  return (
    <div className="dashboard-container">
      <div className="d-flex">
        <Sidebar collapsed={sidebarCollapsed} toggleSidebar={() => setSidebarCollapsed((prev) => !prev)}/>
        <div className="main-content flex-grow-1">
          <DashboardHeader user={user} profilePhoto={profilePhoto} onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />
          <div className="dashboard-content p-4">
            <h2 className="dashboard-title mb-4">Wishlist</h2>

            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : wishlistCourses.length > 0 ? (
              <div className="wishlist-courses">
                {wishlistCourses.map((course) => (
                  <WishlistCourseCard key={course.id} course={course} />
                ))}
              </div>
            ) : (
              <div className="empty-state text-center py-5">
                <i className="fas fa-heart fa-3x text-muted mb-3"></i>
                <h5 className="text-muted">Your wishlist is empty</h5>
                <p className="text-muted">Save courses you're interested in by clicking the heart icon.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default WishlistPage
